export const workExperience = [
  {
    id: "tkww",
    name: "The Knot Worldwide",
    image: "tkww.svg",
    imageHeight: "60px",
    url: "https://www.theknot.com/",
    mainColor: "#92bf54",
    technologies: [
      { text: "React", logo: "react.svg" },
      { text: "Redux", logo: "redux.svg" },
      { text: "Tanstack Query", logo: "tanstack-query.svg" },
      { text: "Next.js", logo: "nextjs.svg" },
      { text: "Node.js", logo: "nodejs.svg" },
      { text: "NestJS", logo: "nestjs.svg" },
      { text: "AWS", logo: "aws.svg" },
      { text: "MongoDB", logo: "mongo.svg" },
      { text: "PostgreSQL", logo: "postgresql.svg" },
      { text: "Jenkins", logo: "jenkins.svg" },
    ],
  },
  {
    id: "celtiberian",
    name: "Celtiberian",
    image: "celtiberian.png",
    imageHeight: "60px",
    url: "https://celtiberian.es/",
    mainColor: "#F65B7C",
    technologies: [
      { text: "React", logo: "react.svg" },
      { text: "Redux", logo: "redux.svg" },
      { text: "Next.js", logo: "nextjs.svg" },
      { text: "Node.js", logo: "nodejs.svg" },
      { text: "NestJS", logo: "nestjs.svg" },
      { text: "Web3", logo: "web3.svg" },
      { text: "Strapi", logo: "strapi.svg" },
      { text: "Stripe", logo: "stripe.svg" },
      { text: "MongoDB", logo: "mongo.svg" },
      { text: "PostgreSQL", logo: "postgresql.svg" },
      { text: "AWS", logo: "aws.svg" },
    ],
  },
  {
    id: "indra",
    name: "Indra",
    image: "indra.png",
    imageHeight: "30px",
    url: "https://www.indracompany.com/",
    mainColor: "#0a7491",
    technologies: [
      { text: "Angular", logo: "angular.svg" },
      { text: "Spring", logo: "spring.svg" },
      { text: "PostgreSQL", logo: "postgresql.svg" },
    ],
  },
  {
    id: "mccm",
    name: "MCCM Innovations",
    image: "mccm.png",
    url: "https://mccminnovations.com",
    mainColor: "#30B35B",
    technologies: [{ text: "UiPath", logo: "uipath.svg" }],
  },
  {
    id: "zuinq",
    name: "Zuinq Studio",
    image: "zuinq.png",
    imageHeight: "50px",
    url: "https://www.zuinqstudio.com/inicio/index.php",
    mainColor: "#D63484",
    technologies: [
      { text: "Vue.js", logo: "vue.svg" },
      { text: "Nuxt", logo: "nuxt.svg" },
      { text: "Node.js", logo: "nodejs.svg" },
      { text: "NestJS", logo: "nestjs.svg" },
      { text: "MongoDB", logo: "mongo.svg" },
      { text: "AWS", logo: "aws.svg" },
    ],
  },
  {
    id: "ntt",
    name: "NTT DATA",
    image: "nttdata.png",
    imageHeight: "25px",
    url: "https://es.nttdata.com/",
    mainColor: "#0073C0",
    technologies: [
      { text: "Angular", logo: "angular.svg" },
      { text: "Jenkins", logo: "jenkins.svg" },
      { text: "SonarQube", logo: "sonarqube.svg" },
    ],
  },
];
